// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fieldRow {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    padding-left: 1rem;
    padding-right: 1rem;
}
.fieldContainer {
    flex: 1 1;
    margin-right: 8px;
}

.textField {
    margin-bottom: 0.1rem;
    width: 100%;
}

.TextareaAutosize {
    width: 100%;
    border-radius: 5px;
}

.select {
    margin-bottom: 0.1rem;
    width: 100%;
}

.radioLabel {
    position: relative;
    top: 0;
    transform: none;
}

.radioLabel .MuiRadio-root {
    position: relative;
    top: 0;
    transform: none;
}

.checkboxLabel {
    position: relative;
    top: 0;
    transform: none;
}

.checkboxLabel .MuiFormControlLabel-label {
    position: relative;
    top: 0;
    transform: none;
}

.smallDatePicker {
    width: 30px;
    height: 24px;
    font-size: 0.75rem;
}

.root {
    margin-top: 24px;
}

.buttonContainer {
    display: flex;
    justify-content: flex-end;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    padding: 10px 0;
    padding-right: 1.5rem;
}

.cancelButton {
    color: #000;
    background-color: #fff;
    max-width: fit-content !important;
}

.cancelButton:hover {
    background-color: #f2f2f2;
}

.submitButton {
    margin-left: 6px;
    background-color: #28a745;
    color: #fff;
}

.submitButton:hover {
    background-color: #218838;
}
.selectedFile{
    position: 'relative';
    border: '1px solid #ccc';
    display: 'inline-block';
    margin: '10px';
}
.deleteButton {
    position: 'absolute';
    top: '5px';
    right: '5px';
    background-Color: 'red';
    color: 'white';
    border: 'none';
    cursor: 'pointer';
    padding: '5px';
  }`, "",{"version":3,"sources":["webpack://./src/app/reusable-components/styles/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,SAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,8BAA8B;IAC9B,+BAA+B;IAC/B,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,oBAAoB;IACpB,wBAAwB;IACxB,uBAAuB;IACvB,cAAc;AAClB;AACA;IACI,oBAAoB;IACpB,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,cAAc;EAChB","sourcesContent":[".fieldRow {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 12px;\n    padding-left: 1rem;\n    padding-right: 1rem;\n}\n.fieldContainer {\n    flex: 1;\n    margin-right: 8px;\n}\n\n.textField {\n    margin-bottom: 0.1rem;\n    width: 100%;\n}\n\n.TextareaAutosize {\n    width: 100%;\n    border-radius: 5px;\n}\n\n.select {\n    margin-bottom: 0.1rem;\n    width: 100%;\n}\n\n.radioLabel {\n    position: relative;\n    top: 0;\n    transform: none;\n}\n\n.radioLabel .MuiRadio-root {\n    position: relative;\n    top: 0;\n    transform: none;\n}\n\n.checkboxLabel {\n    position: relative;\n    top: 0;\n    transform: none;\n}\n\n.checkboxLabel .MuiFormControlLabel-label {\n    position: relative;\n    top: 0;\n    transform: none;\n}\n\n.smallDatePicker {\n    width: 30px;\n    height: 24px;\n    font-size: 0.75rem;\n}\n\n.root {\n    margin-top: 24px;\n}\n\n.buttonContainer {\n    display: flex;\n    justify-content: flex-end;\n    border-bottom-left-radius: 4px;\n    border-bottom-right-radius: 4px;\n    padding: 10px 0;\n    padding-right: 1.5rem;\n}\n\n.cancelButton {\n    color: #000;\n    background-color: #fff;\n    max-width: fit-content !important;\n}\n\n.cancelButton:hover {\n    background-color: #f2f2f2;\n}\n\n.submitButton {\n    margin-left: 6px;\n    background-color: #28a745;\n    color: #fff;\n}\n\n.submitButton:hover {\n    background-color: #218838;\n}\n.selectedFile{\n    position: 'relative';\n    border: '1px solid #ccc';\n    display: 'inline-block';\n    margin: '10px';\n}\n.deleteButton {\n    position: 'absolute';\n    top: '5px';\n    right: '5px';\n    background-Color: 'red';\n    color: 'white';\n    border: 'none';\n    cursor: 'pointer';\n    padding: '5px';\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
